<template>
  <div class="container">
    <div class="secondContainer">
      <div class="box1" id="box1">
        <h1 class="title">Skills</h1>
        <h4>Programming Languages:</h4>
        <div class="expand1" id="expand1">
          <ul class="ull">
            <li>Python</li>
            <li>JavaScript</li>
            <li>PHP</li>
            <li>C++</li>
            <li>Ruby</li>
            <li>Powershell</li>
          </ul>
          <h4>Operating Systems:</h4>
          <ul class="ull">
            <li>CentOS</li>
            <li>Ubuntu</li>
            <li>Oracle EL</li>
            <li>Windows Servers</li>
            <li>Mac OS</li>
            <li>Win 10 (Desktop)</li>
          </ul>
          <h4>Systems Technologies:</h4>
          <ul class="ull">
            <li>Chef</li>
            <li>Jenkins</li>
            <li>Linode</li>
            <li>Phabricator</li>
            <li>VMware</li>
            <li>Windows Servers</li>
            <li>Capirca (Firewall tool)</li>
            <li>Web Services(nginx/apache)</li>
          </ul>
        </div>
        <div class="box-footer">
            <button v-on:click="changeSize1">{{ isExpanded1 ? 'Less' : 'More' }}</button>
        </div>
      </div>
      <div class="box2" id="box2">
        <h1 class="title">Work History</h1>
        <h4>A Gift Inside (Software Engineer):</h4>
        <div class="expand2" id="expand2">
          <p>(Current Employer.)</p>
          <p class="workdate">[08/2017 - Current]</p>
          <p>
            At A Gift Inside, I have been rebuilding their website from an old
            version of CakePHP to the newest version of Laravel / ReactJS / VueJS
            environment.
          </p>
          <ul class="ul-work">
            <li>Migrated all of their MySQL databases over to our new build infrastructure and, made new Models for all the tables moving over.</li>
            <li>Created a “Lane Director” with Raspberry PIs and have them fully managed by Chef.</li>
            <li>Created a GraphQL endpoint and have some queries going against it for our Order Management endpoint.</li>
            <li>Created over 20 CRUD UIs for database tables that are edited by users outside of our Development team.</li>
            <li>Successfully setup Chef server and now maintaining all servers / Raspberry PIs with Chef.</li>
            <li>Currently assist in managing all of our servers. (Mostly Linux / couple Windows servers).</li>
          </ul>
          <h4>Milestone@Facebook (Software Engineer):</h4>
          <p class="workdate">[03/2017 - 08/2017]</p>
          <p>
            As a Software Engineer contractor on Facebooks BizApps team, I helped develop internal
            Facebook application webpages that help automate business-driven teams.
          </p>
          <ul class="ul-work">
            <li>Spent time programming dynamic webpages (Front End / Back End) in Facebooks version of PHP called <a href="http://hacklang.org/">Hack</a> and ReactJS, and some React Native JS.</li>
            <li>Worked exyensively with <a href="http://graphql.org/">GraphQL</a> to manage queries to various Databases</li>
            <li>Worked with <a href="http://redux.js.org/">Redux</a> to help manage states across multiple apps. (Mainly on an application we built to help automate our helpdesks jobs / interaction with Facebooks ticketing system.)</li>
            <li>Supported some existing Python applications that we have been working on migrating towards our internal stack for better performance. (Re writing a lot of Python code in Hack/ReactJS).</li>
            <li>Created various ReactJS Components for things like typeaheads, asset validators that talked to Oracle to see if a specific asset is available or not.</li>
            <li>Created a few bots to handle very specific work flows and updates for managers.</li>
            <li>Played alot of Foosball and tinkered with Raspberry PIs for reading vending machine asset data</li>
          </ul>
          <h4>Milestone@Facebook (Infrastructure Operation / Lead):</h4>
          <p class="workdate">[10/2014 - 03/2017]</p>
          <p>
            As a Systems Engineer contractor on Facebooks Infrastructure Operations team.
            I helped manage thousands of servers that ran several teams operations and services.
          </p>
          <ul class="ul-work">
            <li>Provided Infrastructure Operations support for Internal Facebook employees and automated as much as possible.</li>
            <li>Worked with various internal teams to help automate painful processes.</li>
            <li>VMWare – Deployed, troubleshooted, and managed everything in VMware vSphere (Consists: VMware ESXi and VMWare vCenter Server). Perform backups if needed.</li>
            <li>Windows Server OS – Maintained hundreds of Windows Server 2008/2012 r2 servers. Perform configurations using Chef, maintained updates and troubleshooted various services and network issues. Helped automate lots of operational work using PowerShell.</li>
            <li>Linux OS – Maintained hundreds of Linux servers both RHEL and Debian. Maintained CentOS 5.x/6.x/7.x, Ubuntu 14.04/16.04, and Oracle Enterprise Linux 6.x and various vendor Linux distribution types. Maintained all Linux hosts with Chef.</li>
            <li>DNS – Kept all computers managed by DNS</li>
            <li>FW ACLs – Created FW rules for various reasons using the open source tool called Caprica.</li>
            <li>Exchange /Office 365 – Various outlook troubleshooting for end users. Maintained various exchange database servers. Helped automate lots of operational work using PowerShell.</li>
            <li>SCCM /Chef – Used SCCM a little bit, but mainly performed all configuration management with Chef. Used Chef to create various cookbooks/recipes for several different tiers of VMs.</li>
            <li>Active Directory - Maintained and helped automate lots of operational work using PowerShell.</li>
            <li>Group Policy – Configured various GPO’s and assisted with clean-up of GPO’s.</li>
            <li>Maintained tools used by the Infra Ops and other Engineering teams</li>
            <li>Citrix - Maintained and troubleshooted the Citrix XenApp and XenDesktop environment. Troubleshooted end-user Citrix client application issues.</li>
            <li>Source Control – Troubleshooted and assisted other engineers and developers having issues with resources like Mecurial, Git, and Arcanist.</li>
          </ul>
          <h4>United States Army (25L/Cable Systems Installer):</h4>
          <p class="workdate">[12/2008 - 12/2014]</p>
          <ul>
            <li>Two Operation Enduring Freedom Deployments (Afghanistan / Jordan).</li>
            <li>For a year in Afghanistan, I was in charge of an NOC (Network Operations Center), where I learned about being a system administrator and scripting (mostly JavaScript to make NagWare Pop-ups & PowerShell to put NagWare on PCs under our domain).</li>
            <li>Last 3 years in the Military, I served as an E-5 (Sergeant).</li>
          </ul>
        </div>
        <div class="box-footer">
            <button v-on:click="changeSize2">{{ isExpanded2 ? 'Less' : 'More' }}</button>
        </div>
      </div>
      <div class="box3" id="box3">
        <h1 class="title">Education</h1>
        <h4>Butte College (Chico, CA)</h4>
        <div class="expand3" id="expand3" >
          <p>
            I am 3 classes short of having my AS in Computer Science from Butte College. =/
            I plan on continuing my education at Sacramento State University later in 2018.
          </p>
        </div>
        <div class="box-footer">
            <button v-on:click="changeSize3">{{ isExpanded3 ? 'Less' : 'More' }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
export default {
  name: 'Resume',
  components: {
    AppHeader
  },
  methods: {
    changeSize1 () {
      document.getElementById('box1').style.overflowY =
        (document.getElementById('box1').style.height === '200px') ? 'auto' : 'none'
      document.getElementById('expand1').style.height =
        (document.getElementById('expand1').style.height === '0px') ? 'auto' : '0px'
      document.getElementById('box1').style.height =
        (document.getElementById('box1').style.height === '200px') ? '700px' : '200px'
      if (document.getElementById('box1').style.height === '200px') {
        this.$set(this, 'isExpanded1', false)
      } else {
        this.$set(this, 'isExpanded1', true)
      }
    },
    changeSize2 () {
      document.getElementById('expand2').style.height =
        (document.getElementById('expand2').style.height === '0px') ? 'auto' : '0px'
      document.getElementById('box2').style.height =
        (document.getElementById('box2').style.height === '200px') ? '700px' : '200px'
      document.getElementById('box2').style.overflowY =
        (document.getElementById('box2').style.height === '200px') ? 'auto' : 'none'
      if (document.getElementById('box2').style.height === '200px') {
        this.$set(this, 'isExpanded2', false)
      } else {
        this.$set(this, 'isExpanded2', true)
      }
    },
    changeSize3 () {
      document.getElementById('box3').style.height =
        (document.getElementById('box3').style.height === '200px') ? '285px' : '200px'
      document.getElementById('expand3').style.height =
        (document.getElementById('expand3').style.height === '0px') ? 'auto' : '0px'
      if (document.getElementById('box3').style.height === '200px') {
        this.$set(this, 'isExpanded3', false)
      } else {
        this.$set(this, 'isExpanded3', true)
      }
    }
  },
  data () {
    return {
      isExpanded1: false,
      isExpanded2: false,
      isExpanded3: false
    }
  }
}
</script>
<!--     margin-top: auto;
    margin-left: auto;
    margin-bottom: 25px;
    margin-right: auto;

    -->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .expand1 {
    height: 0px;
    overflow: hidden;
    transition-property: height;
    transition-duration: .4s;
    transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
    &[aria-expanded1="false"] {
      height: 0 !important;
      transition-timing-function: cubic-bezier(0.6, -0.28, 0.735, 0.045);
    }
  }
  .expand2 {
    overflow: hidden;
    height: 0px;
    transition-property: height;
    transition-duration: .4s;
    transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
    &[aria-expanded2="false"] {
      height: 0 !important;
      transition-timing-function: cubic-bezier(0.6, -0.28, 0.735, 0.045);
    }
  }
  .expand3 {
    height: 0px;
    overflow: hidden;
    transition-property: height;
    transition-duration: .4s;
    transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
    &[aria-expanded3="false"] {
      height: 0 !important;
      transition-timing-function: cubic-bezier(0.6, -0.28, 0.735, 0.045);
    }
  }

  .u-no-transition {
    transition-duration: 0s !important;
  }
  @import url('https://fonts.googleapis.com/css?family=Raleway');
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  .skills {
    padding: 25px;
  }
  .work-history {
    padding: 25px;
  }
  .education {
    padding: 25px;
  }
  .container {
    text-align: center;
    align-items: center;
  }
  h1 {
    margin-top: 0;
    text-align: center;
    font-size: 1.8em;
  }
  .box1 {
    background-color: salmon;
    height: 200px;
    max-width: 360px;
    margin: 15px;
    padding: 24px;
    border-radius: 3px;
    background-image: linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%);
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
    &-footer {
      padding-top: calc(24px - .5em);
      text-align: center;
    }
  }
  .box2 {
    background-color: salmon;
    height: 200px;
    max-width: 360px;
    margin: 15px;
    padding: 24px;
    border-radius: 3px;
    background-image: linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%);
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
    &-footer {
      padding-top: calc(24px - .5em);
      text-align: center;
    }
  }
  .box3 {
    background-color: salmon;
    height: 200px;
    max-width: 360px;
    margin: 15px;
    padding: 24px;
    border-radius: 3px;
    background-image: linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%);
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
    &-footer {
      padding-top: calc(24px - .5em);
      text-align: center;
    }
  }
  button {
    padding-top: 6px;
    padding-bottom: 6px;
    padding-left: 12px;
    padding-right: 12px;
    border-width: 0;
    border-radius: 3px;
    background-image: linear-gradient(-20deg, #fc6076 0%, #ff9a44 100%);
    font-family: inherit;
    font-size: 1.1em;
    color: #fff;
    transform: translateY(0);
    transition-property: box-shadow;
    transition-duration: .2s;
    transition-timing-function: ease-out;
    cursor: pointer;
    &:hover {
      box-shadow: 0 0 6px #ff9a44;
    }
    &:focus {
      outline: none;
      box-shadow: 0 0 20px #ff9a44;
    }
  }
  code {
    padding: 0 5px 2px;
    border-radius: 4px;
    background-color: #dfdfdf;
    font-size: .9em;
  }
  li {

  }
  p {
    margin-top: 0;
    margin-bottom: .5em;
  }
  .ull {
    list-style-type: none;
    margin-left: -42px;
    margin-top: -5px;
  }
  li {
    padding: 3px;
  }
  .workdate {
    color: red;
  }
  a {
    color: #fe8854;
    font-weight: 500;
    text-decoration: none !important;
  }
  .secondContainer {
    display: inline-flex;
  }
  @media only screen and (max-width: 768px) {
    .secondContainer {
      display: block;
    }
    .box {
      margin-top: auto;
      margin-left: auto;
      margin-bottom: 25px;
      margin-right: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Resume.vue